// MobileSignUpForm.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import backArrowSVG from "../../assets/images/back-arrow.svg";
import { apiServices } from "../../services/Api";

const MobileSignUpForm = () => {
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("+91");
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");

  // Function to handle form submission
  const handleSubmit = async () => {
    // Validate mobile number
    if (!mobileNumber.match(/^[0-9]{10}$/)) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    } else {
      setError("");
      // Proceed with form submission
      // console.log('Country Code:', countryCode);
      console.log("Mobile Number:", mobileNumber);
      let sessionId = "";

      try {
        const response = await apiServices.post(
          "auth/otp/send",
          { phoneNumber: mobileNumber },
          {}
        );
        sessionId = response;
        sessionId = sessionId.replace(/-/g, "");
        navigate("/otpverify", { state: { sessionId, mobileNumber } });
      } catch (error) {
        console.log("Error:", error);
      }
    }
  };

  // Handle back button click
  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col font-['Roboto',sans-serif] w-[32.6875rem] mx-auto bg-white p-6 rounded-lg gap-8 shadow-[0_0_10px_rgba(0,0,0,0.1)] max-md:w-full max-md:rounded-none">
      <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
        <div className="flex items-center justify-center rounded-lg border border-[#939393] bg-white p-3.5 cursor-pointer max-md:hidden" onClick={handleBackButtonClick}>
          <img src={backArrowSVG} width={24} height={24} />
        </div>
        <div>
          <h2 className="text-[#454545] text-2xl font-bold leading-normal mb-2 max-md:text-xl">Create Account</h2>
          <p className="mb-5 text-[#9D9D9D] text-[15px] font-normal leading-normal max-md:text-xs" style={{ margin: "0" }}>
            Please enter your mobile number to register & receive OTP
          </p>
        </div>
      </div>
      <hr className="border-[0.6px] border-[#EBEBEB]" />
      <div>
        <p className="text-[#454545] text-base font-normal leading-normal mb-2">Enter mobile number</p>
        <div className="flex">
          <select
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            className="flex h-11 items-center flex-[2] w-full py-2.5 px-3 rounded-lg border border-brand-border bg-white text-[#222222] text-base font-normal leading-normal mr-2"
          >
            <option value="+1">+1</option>
            <option value="+91">+91</option>
            <option value="+91">+91</option>

            {/* Add more options as needed */}
          </select>
          <input
            type="text"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            placeholder="Enter your mobile number"
            className="flex h-11 items-center flex-[10] w-full py-2.5 px-3 rounded-lg border border-brand-border bg-white text-[#9D9D9D] text-base font-normal leading-normal mb-0"
          />
        </div>
        {error && <span className="text-red-600 font-['Roboto',sans-serif] text-xs">{error}</span>}
      </div>
      <div>
        <button onClick={handleSubmit} className="text-white h-11 py-2.5 px-7 border-none rounded-lg bg-primary cursor-pointer text-base w-full mb-5">
          Request OTP
        </button>
      </div>
    </div>
  );
};

export default MobileSignUpForm;
